import React from 'react';
import { useTranslation } from 'react-i18next';
import { C } from '../albumColors';
import useIsMobile from '../hooks/useIsMobile';

/**
 * Popover/sheet con 5 estrellas y un "Reiniciar" para devolver al default (1).
 * En mobile aparece como bottom sheet; en desktop como modal centrado pequeño.
 */
function ValuationPicker({ stickerNum, currentValue, onPick, onClose }) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const value = currentValue ?? 1;

  const wrapperClass = isMobile
    ? 'absolute bottom-0 inset-x-0 rounded-t-2xl flex flex-col'
    : 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[min(360px,92vw)] rounded-2xl flex flex-col';

  const Star = ({ index }) => {
    const filled = index <= value;
    return (
      <button
        onClick={() => onPick(index)}
        className="p-1 transition-transform hover:scale-110"
        aria-label={t('Lo valoro {{value}}/5', { value: index })}
      >
        <span
          className="material-symbols-outlined"
          style={{
            fontSize: 32,
            color: filled ? '#F59E0B' : C.outlineVariant,
            fontVariationSettings: filled ? "'FILL' 1" : "'FILL' 0",
          }}
        >
          star
        </span>
      </button>
    );
  };

  return (
    <div className="fixed inset-0 z-[110]">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} aria-hidden="true" />
      <div
        role="dialog"
        aria-modal="true"
        className={`${wrapperClass} shadow-2xl`}
        style={{ backgroundColor: C.surface, border: `1px solid ${C.outlineVariant}33` }}
      >
        <div className="flex items-center justify-between px-4 pt-4 pb-1 shrink-0">
          <h3 className="text-sm font-black uppercase tracking-widest" style={{ color: C.onSurface }}>
            {t('Valor')} · #{stickerNum}
          </h3>
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-black/5"
            aria-label={t('Cerrar')}
          >
            <span className="material-symbols-outlined text-lg">close</span>
          </button>
        </div>
        <p className="px-4 text-[11px] mb-2" style={{ color: C.onSurfaceVariant }}>
          {t('Cuánto la valoras (afecta los intercambios rápidos).')}
        </p>
        <div className="flex items-center justify-center gap-1 py-3">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} index={i} />)}
        </div>
        <div className="flex items-center justify-between px-4 pb-4 pt-1">
          <button
            onClick={() => onPick(1)}
            className="text-[11px] font-bold uppercase tracking-wide hover:opacity-70"
            style={{ color: C.onSurfaceVariant }}
          >
            {t('Reiniciar valor')}
          </button>
          <span className="text-[11px] font-bold tabular-nums" style={{ color: C.onSurfaceVariant }}>
            {value}/5
          </span>
        </div>
      </div>
    </div>
  );
}

export default ValuationPicker;
